import pkg from "../../package.json";

export class Constantes {
	static readonly PUESTO_OPE = "No existen OPEs";

	static readonly UBICACION_PERDIDOS = "Z00Z00";

	static readonly existenSubfamilias: boolean = false;

	static readonly articulosDesubicados: boolean = true;

	static readonly elegirComponentesOF: boolean = true;

	static readonly existenCiclos: boolean = false;

	static readonly existenFases: boolean = false;

	static readonly existenLotes: boolean = true;
}


export const REGEX_CONTENEDOR = /(^@\d+$)/;
export const REGEX_UBICACION = /(^[A-Z]{1}\d{2}[A-Z]{1}\d{2}$)/;
export const REGEX_PUESTO = /(^P-\d{2}$)/;
export const REGEX_CUALQUIERA = /(^[A-Z]{1}\d{2}[A-Z]{1}\d{2}$)|(^P-\d{2}$)|(^\d+$)/;


export const BASE_API_URL = localStorage.getItem(pkg.name + ".BASE_API_URL") ?? "https://api.almacen.rial.wundersolutions.es";